<template>
  <div>Supplier Order Show View</div>
</template>

<script>
export default {
  name: 'SupplierOrderShow',
};
</script>
